<template>
  <div>
    <div class="container position-sticky z-index-sticky top-0">
      <div class="row">
        <div class="col-12">
          <!-- Navbar -->
          <nav
            class="navbar navbar-expand-lg blur blur-rounded top-0 z-index-3 shadow position-absolute my-3 py-2 start-0 end-0 mx-4"
          >
            <div class="container-fluid pe-0">
              <img
                src="../../core_assets/img/CCD_LOGO_2.png"
                class="navbar-brand-img img-fluid"
                alt="main_logo"
                style="height: 80px !important; width: 80px !important"
              />
              <button
                class="navbar-toggler shadow-none ms-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navigation"
                aria-controls="navigation"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon mt-2">
                  <span class="navbar-toggler-bar bar1"></span>
                  <span class="navbar-toggler-bar bar2"></span>
                  <span class="navbar-toggler-bar bar3"></span>
                </span>
              </button>
              <div class="collapse navbar-collapse" id="navigation">
                <ul class="navbar-nav mx-auto ms-xl-auto me-xl-7">
                  <!-- <li class="nav-item">
                    <a class="nav-link me-2" href="login">
                      <i class="fas fa-key opacity-6 text-dark me-1"></i>
                      Inicio
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link me-2" href="about">
                      <i class="fas fa-key opacity-6 text-dark me-1"></i>
                      SIFVF
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link me-2" href="About.vue">
                      <i class="fas fa-key opacity-6 text-dark me-1"></i>
                      El equipo
                    </a>
                  </li> -->
                </ul>
                <li class="nav-item d-flex align-items-center">
                  <a
                    class="btn btn-round btn-sm mb-0 btn-outline-primary me-2"
                    href="login"
                    >Accceder</a
                  >
                </li>
                <ul class="navbar-nav d-lg-block d-none"></ul>
              </div>
            </div>
          </nav>
          <!-- End Navbar -->
        </div>
      </div>
    </div>
    <main class="main-content mt-0">
      <section>
        <div class="page-header min-vh-75 mt-6 align-items-center d-flex">
          <div class="container">
            <div class="row">
              <div class="col-lg-2 col-md-3"></div>
              <div class="col-lg-8 col-md-6 ms-lg-8">
                <br /><br />
                <div class="card mt-2">
                  <div class="card-body">
                    <form role="form">
                      <div v-if="step == 1">
                        <div class="text-center text-muted mb-4">
                          <h2>Paso 1</h2>
                          <p>Recuperación de contraseña</p>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <base-input
                              label="Indica tu correo para recibir un código de validación"
                              type="email"
                              v-model.trim="form_save.email"
                              v-on:keyup.enter="sendCodeEmail"
                              placeholder="Correo electrónico"
                            ></base-input>
                          </div>
                        </div>

                        <div class="text-center">
                          <br />
                          <button
                            type="button"
                            class="btn bg-gradient-fvf"
                            @click="sendCodeEmail"
                          >
                            <span>Siguiente</span>
                          </button>
                        </div>
                      </div>
                      <div v-if="step == 2">
                        <div class="text-center text-muted mb-4">
                          <h2>Paso 2</h2>
                          <p>Indica el código que llegó a tu correo</p>
                        </div>

                        <div class="row">
                          <div class="col-md-12" v-if="!form_save.email">
                            <base-input
                              label="Correo electrónico"
                              type="email"
                              v-model.trim="form_save.email"
                              placeholder="Indica tu correo"
                              autocomplete="email"
                            ></base-input>
                          </div>
                          <div class="col-md-12">
                            <base-input
                              label="Código de verificación"
                              type="text"
                              v-model="form_save.verif_code"
                              placeholder="Ingresa el código que recibiste por correo"
                              autocomplete="off"
                            ></base-input>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-md-12">
                            <div class="text-center">
                              <button
                                type="button"
                                class="btn bg-gradient-fvf"
                                @click="verifyVerificationCode"
                              >
                                <span>Verificar</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="step == 3">
                        <div class="text-center text-muted mb-4">
                          <h2>Paso 3</h2>
                          <p>Ingresa tu nueva contraseña</p>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <base-input
                              label="Nueva contraseña"
                              type="password"
                              v-model="form_save.password"
                              placeholder="Indica tu nueva contraseña"
                              autocomplete="new-password"
                            ></base-input>
                          </div>
                          <div class="col-md-12">
                            <base-input
                              label="Confirma tu nueva contraseña"
                              type="password"
                              v-model="form_save.password2"
                              placeholder="Repite tu nueva contraseña"
                              autocomplete="new-password"
                            ></base-input>
                          </div>
                        </div>

                        <br />
                        <div class="row">
                          <div class="col-md-12">
                            <div class="text-center">
                              <button
                                type="button"
                                class="btn bg-gradient-fvf"
                                @click="setNewPassword"
                              >
                                <span>Actualizar</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-3"></div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!-- -------- START FOOTER 3 w/ COMPANY DESCRIPTION WITH LINKS & SOCIAL ICONS & COPYRIGHT ------- -->
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import LayoutFooter from "./Layouts/Footer";
import { mapActions } from "vuex";
import Multiselect from "vue-multiselect";
import EmailValidator from "email-validator";
export default {
  name: "register",
  components: {
    Multiselect,
    LayoutFooter,
  },
  data() {
    return {
      codeData: {},
      // first page
      step: 1,
      form_save: {
        email: "",
        verif_code: "",
        password: "",
        password2: "",
      },
    };
  },
  mounted() {
    if (this.$route.query.token) {
      this.form_save.verif_code = this.$route.query.token;
      this.step = 2;
    }
  },
  methods: {
    ...mapActions([
      "login",
      "getData",
      "createData",
      "updateDataClean",
      "recoverData",
      "recoverPassword",
    ]),

    sendCodeEmail() {
      if (!this.mailValidator()) return;
      let data_to_send = {
        email: this.form_save.email,
      };
      let form = {
        url: "security/recover_password",
        data: data_to_send,
      };

      this.recoverData(form)
        .then((response) => {
          if (response.code === 200) {
            this.deleting = false;
            Swal.fire({
              title: "Correo enviado",
              text: "Hemos enviado un código a tu correo para que puedas recuperar tu contraseña",
              icon: "success",
              showConfirmButton: true,
              showLoaderOnConfirm: true,
            }).then((result) => {
              console.log(result);
              this.step = 2;
            });
          }
          if (response.code === 408) {
            this.deleting = false;

            //this.AllElements();
          }
          if (response.code === 404) {
            this.deleting = false;

            Swal.fire({
              title: "Correo no encontrado",
              text: "El correo que ingresaste no está registrado",
              icon: "warning",
              showConfirmButton: true,
              showLoaderOnConfirm: true,
            }).then((result) => {
              console.log(result);
            });
          }
          if (response.code === 409) {
            this.deleting = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.deleting = false;
          alert("Ocurrió un error, intente más tarde");
          this.AllElements();
        });
    },

    verifyVerificationCode() {
      if (!this.mailValidator()) return;
      if (!this.form_save.verif_code) {
        Swal.fire({
          title: "Código requerido",
          text: "Debes ingresar el código de verificación",
          icon: "warning",
        });
        return;
      }

      const data_to_send = {
        email: this.form_save.email,
        verif_code: this.form_save.verif_code,
      };

      const form = {
        url: "auth/verify_verification_code",
        data: data_to_send,
      };

      this.recoverData(form)
        .then((response) => {
          if (response.code === 200) {
            Swal.fire({
              title: "Código verificado",
              text: "El código es válido. Ahora puedes cambiar tu contraseña.",
              icon: "success",
              showConfirmButton: true,
              showLoaderOnConfirm: true,
            }).then(() => {
              this.step = 3;
            });
            return;
          }

          Swal.fire({
            title: "Código inválido",
            text: "El código ingresado es inválido o ha expirado",
            icon: "warning",
            showConfirmButton: true,
          });
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ocurrió un error, intente más tarde",
            icon: "error",
            showConfirmButton: true,
          });
        });
    },

    setNewPassword() {
      if (!this.mailValidator()) return;
      if (!this.form_save.verif_code) {
        Swal.fire({
          title: "Código requerido",
          text: "Debes ingresar el código de verificación",
          icon: "warning",
        });
        this.step = 2;
        return;
      }

      if (!this.form_save.password || !this.form_save.password2) {
        Swal.fire({
          title: "Contraseña requerida",
          text: "Debes indicar y confirmar tu nueva contraseña",
          icon: "warning",
        });
        return;
      }

      if (this.form_save.password.length < 8) {
        Swal.fire({
          title: "Contraseña corta",
          text: "La contraseña debe tener al menos 8 caracteres",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      }

      if (this.form_save.password !== this.form_save.password2) {
        Swal.fire({
          title: "Contraseñas no coinciden",
          text: "Las contraseñas no coinciden, por favor verifica que sean iguales",
          icon: "warning",
        });
        return;
      }

      const data_to_send = {
        code: this.form_save.verif_code,
        password: this.form_save.password,
        email: this.form_save.email,
      };

      const form = {
        url: "auth/set_new_password/",
        data: data_to_send,
      };

      this.recoverData(form)
        .then((response) => {
          if (response.code === 200) {
            Swal.fire({
              title: "Contraseña actualizada",
              text: "Tu contraseña ha sido actualizada con éxito",
              icon: "success",
              showConfirmButton: true,
              showLoaderOnConfirm: true,
            }).then(() => {
              this.$router.push("/login");
            });
            return;
          }

          Swal.fire({
            title: "No se pudo actualizar",
            text: "Verifica el código y vuelve a intentar",
            icon: "warning",
            showConfirmButton: true,
          });
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ocurrió un error, intente más tarde",
            icon: "error",
            showConfirmButton: true,
          });
        });
    },

    mailValidator() {
      if (!this.form_save.email) {
        Swal.fire({
          title: "Email requerido",
          text: "Debes indicar tu correo electrónico para poder continuar",
          icon: "warning",
        });
        return false;
      }
      let validate = EmailValidator.validate(this.form_save.email);
      if (!validate) {
        Swal.fire({
          title: "Email inválido",
          text: "Debes escribir un email válido para poder continuar",
          icon: "warning",
        });
        return false;
      }

      return true;
    },

    // nextStep(actualStep) {
    //   if (actualStep == 1) {
    //     if (
    //       this.form_save.email == ""

    //     ) {
    //       Swal.fire({
    //         title: "Completa los datos",
    //         text: "Debes completar todos los datos para continuar",
    //         icon: "warning",
    //       });
    //     } else {

    //       let validate = EmailValidator.validate(this.form_save.email);

    //       if (!validate) {
    //         Swal.fire({
    //           title: "Email inválido",
    //           text: "Debes escribir un email válido para poder continuar",
    //           icon: "warning",
    //         });
    //       } else {
    //         this.step = 2;
    //       }

    //     }
    //   }
    //   if (actualStep == 2) {
    //    if (
    //       this.form_save.verif_code == ""
    //       ) {
    //       Swal.fire({
    //         title: "Completa los datos",
    //         text: "Debes completar todos los datos para continuar",
    //         icon: "warning",
    //       });
    //     }  else {
    //       this.step = 3;
    //     }
    //   }
    //   if (actualStep == 3) {

    //     this.step = 4;
    //   }
    //   if (actualStep == 4) {
    //     this.step = 5;
    //   }
    // },
  },
};
</script>
<style>
.gradient-custom-2 {
  /* fallback for old browsers */
  background: #fccb90;

  /* Chrome 10-25, Safari 5.1-6 */
  background: -webkit-linear-gradient(
    to right,
    #ee7724,
    #d8363a,
    #dd3675,
    #b44593
  );

  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background: linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593);
}

@media (min-width: 768px) {
  .gradient-form {
    height: 100vh !important;
  }
}

@media (min-width: 769px) {
  /* .gradient-custom-2 {
      border-top-right-radius: 0.3rem;
      border-bottom-right-radius: 0.3rem;
    } */
}
</style>
